import AuthController from '@/controllers/AuthController'
import AxiosController from '@/controllers/AxiosController'
import router from '@/router'
import echo from '@/utils/echo.js'

const state = {
    token: localStorage.getItem('token') || '',
    user: null
}
const mutations = {
    auth_success(state, payload) {
        state.token = payload.access_token
        state.user = payload.user
    },
    auth_logout(state) {
        state.token = ''
        state.user = null
    },
    set_user(state, payload) {
        state.user = payload
    },
    set_has_access(state, payload) {
        state.user.has_access = payload
    }
}
const actions = {
    login({ commit, dispatch }, payload) {
        const { usernameOrEmail, password } = payload
        AuthController.login({ usernameOrEmail, password }).then(res => {
            if (res) {
                this.dispatch('setLanguage', res.data.user.lang)
                commit('auth_success', res.data)
                router.push('/user/me')
            }
        })
    },
    socialLogin({ commit, dispatch }, payload) {
        const { lang, mode, provider, code } = payload
        AxiosController.post('/auth/sociallogin', { lang, mode, provider, code }).then(res => {
            commit('auth_success', res.data)
            router.push('/user/me')
        })
    },
    appleLogin({ commit, dispatch }, payload) {
        const { lang, code, email, givenName, familyName } = payload
        AxiosController.post('/auth/applelogin', { lang, code, email, givenName, familyName }).then(res => {
            commit('auth_success', res.data)
            router.push('/user/me')
        })
    },
    autoLogin({ commit, dispatch }, payload) {
        const token = payload
        AuthController.autoLogin(token)
            .then(res => {
                commit('auth_success', { token, user: res.data })
                this.dispatch('setLanguage', res.data.lang)
                const { options } = res.data
                if (!options.find(({ type }) => type === 'purpose')) {
                    router.push('/edit-profile')
                }
            })
            .catch(() => {
                localStorage.removeItem('token')
                if (window.Echo && state.user) {
                    window.Echo.leave(`messages.${state.user.id}`)
                    window.Echo.leave(`banned.${state.user.id}`)
                    window.Echo.leave(`App.User.${state.user.id}`)
                }
                commit('auth_logout')
            })
    },
    logout({ commit }) {
        localStorage.removeItem('token')
        if (window.Echo && state.user) {
            window.Echo.leave(`messages.${state.user.id}`)
            window.Echo.leave(`banned.${state.user.id}`)
            window.Echo.leave(`App.User.${state.user.id}`)
        }
        commit('auth_logout')
    },
    signup({ commit, dispatch }, payload) {
        AuthController.signup(payload)
            .then(res => {
                if (res) {
                    commit('auth_success', res.data)
                    router.push('/register/step-2')
                }
            })
            .catch(err => {
                const { error } = err.data
                let formattedErrors = ''
                if (error.email) {
                    //we should add translation here that replaces the english message based on language
                    formattedErrors += '\n\r' + error.email
                }
                if (error.name) {
                    //we should add translation here that replaces the english message based on language
                    formattedErrors += '\n\r' + error.name
                }
                dispatch('setError', { error: formattedErrors }, { root: true })
            })
    },
    setUser({ commit }, payload) {
        commit('set_user', payload)
    },
    setHasAccess({ commit }, payload) {
        commit('set_has_access', payload)
    }
}
const getters = {
    token: state => state.token,
    user: state => state.user
}

export default { state, actions, mutations, getters }
